import Resize from './directives/resize'
import Touch from './directives/touch'
import Scroll from './directives/scroll'
import Mousemove from './directives/mousemove'
import Radio from './directives/radio'


Plugin.install = function(Vue, options) {
  Vue.directive('resize', Resize)
  Vue.directive('touch', Touch)
  Vue.directive('scroll', Scroll)
  Vue.directive('mousemove', Mousemove)
  Vue.directive('radio', Radio)
};

export default Plugin;